import { toast } from 'react-toastify';

// Valor do ID de país/cidade quando o usuário digitou um texto mas não escolheu nenhum item da lista.
// Os demais valores continuam: '' = campo vazio (ou texto vindo do GET) e número = ID escolhido.
export const UNSELECTED_LOCATION = null;

// Texto de país/cidade vindo do GET para exibir no campo. Aceita string ou objeto { name };
// qualquer outro formato (ID, null...) vira '' para nunca quebrar o formulário.
export const locationLabel = (value) => {
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object' && typeof value.name === 'string') return value.name;
  return '';
};

// Estado do ID após o usuário digitar no campo: texto sem escolha na lista bloqueia o envio
export const locationIdFromTypedText = (text) => (
  String(text || '').trim() === '' ? '' : UNSELECTED_LOCATION
);

// Só vale o que foi selecionado na lista; texto digitado à mão gera erro e impede o envio
export const validateLocationSelection = ({ nationality_country, naturalness_city }) => {
  if (nationality_country === UNSELECTED_LOCATION) {
    toast.error('Selecione a nacionalidade na lista de países.');
    return false;
  }
  if (naturalness_city === UNSELECTED_LOCATION) {
    toast.error('Selecione a naturalidade na lista de cidades.');
    return false;
  }
  return true;
};
